import React from 'react';
import { Header5, useFormContextRequired } from 'ui-builder';
import { Person } from 'nekst-api';
import { SanitizedHtmlPreview } from 'features/nekst-widgets';

export function SignatureHtmlPreview() {
  const formContext = useFormContextRequired<Person>();
  const signature = formContext.data?.profile?.emailSignature;

  if (!signature) {
    return null;
  }

  return (
    <div style={{ marginTop: -12 }}>
      <Header5>Signature Preview</Header5>
      <SanitizedHtmlPreview html={signature} />
    </div>
  );
}
